import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

/**
 * Line chart to display the pause list
 */

interface PauseListChartProps {
    datasets: Array<Array<number>>;
}

export const PauseListChart = ({ datasets }: PauseListChartProps) => {
    const plugins: Array<any> = [
        {
            beforeDraw: (chart: any) => {
                const ctx = chart.canvas.getContext('2d');
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = 'black';
                ctx.fillRect(
                    chart.chartArea.left,
                    chart.chartArea.top,
                    chart.chartArea.right - chart.chartArea.left,
                    chart.chartArea.bottom - chart.chartArea.top
                );
                ctx.restore();
            },
        },
    ];

    const options: any = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },

        scales: {
            xAxis: {
                ticks: {
                    callback: function (value: any, index: any, values: any) {
                        return value / 1000 + 'secs';
                    },
                },
                type: 'linear',
            },
            yAxes: {
                ticks: {
                    display: false,
                },
            },
        },
        datasetFill: true,
        chartArea: {
            backgroundColor: 'rgba(251, 85, 85, 0.4)',
        },
        elements: {
            point: {
                borderWidth: 0,
                radius: 10,
                backgroundColor: 'rgba(0,0,0,0)',
            },
        },
    };

    // See api.mock.ts to see an example of the api
    // We need to create the pause "block" by indicating when to go up and down
    const formattedData = useMemo(() => {
        return datasets.reduce((acc: any, data: any) => {
            const data1 = {
                x: data[0],
                y: 0,
            };

            const data2 = {
                x: data[0],
                y: 1,
            };

            const data3 = {
                x: data[1],
                y: 1,
            };

            const data4 = {
                x: data[1],
                y: 0,
            };
            return [...acc, data1, data2, data3, data4];
        }, []);
    }, [datasets]);

    const data = {
        datasets: [
            {
                label: 'Pause List',
                lineTension: 0,
                fill: {
                    target: 'origin',
                    above: '#BC5D7F', // Area will be red above the origin
                },
                data: formattedData,
            },
        ],
    };

    return <Line options={options} data={data} plugins={plugins} />;
};
